{
  "showAllButtonLabel": "Show all ({tagCount})",
  "hideButtonLabel": "Show less",
  "actions": "Actions"
}